import { useState, useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';

interface CountdownTimerProps {
  seconds: number;
  onResend: () => void;
  disabled?: boolean;
}

export default function CountdownTimer({ seconds, onResend, disabled = false }: CountdownTimerProps) {
  const { t } = useLanguage();
  const [remaining, setRemaining] = useState(seconds);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    setRemaining(seconds);
    setCanResend(false);
  }, [seconds]);

  useEffect(() => {
    if (remaining <= 0) {
      setCanResend(true);
      return;
    }
    const timer = setTimeout(() => setRemaining(remaining - 1), 1000);
    return () => clearTimeout(timer);
  }, [remaining]);

  const handleResend = () => {
    if (!canResend || disabled) return;
    setCanResend(false);
    setRemaining(seconds);
    onResend();
  };

  if (canResend) {
    return (
      <button
        type="button"
        className="resend-link"
        onClick={handleResend}
        disabled={disabled}
      >
        {t('auth.otp.resend')}
      </button>
    );
  }

  const mins = Math.floor(remaining / 60);
  const secs = remaining % 60;

  return (
    <span className="countdown-timer">
      {t('auth.otp.resendIn')} {mins > 0 ? `${mins}:` : ''}{secs.toString().padStart(2, '0')}s
    </span>
  );
}
